var _effectorFileName = "/builds/gmini/front-common/src/metrika/provider.tsx";
import { YMInitializer } from 'react-yandex-metrika';
import React from 'react';
import { yandexMetrikaDisabled } from "./env";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MetrikaProvider = function MetrikaProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!yandexMetrikaDisabled && /*#__PURE__*/_jsx(YMInitializer, {
      accounts: [70864876],
      options: {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true
      }
    }), children]
  });
};